module.exports = "<div class=\"form-group row\">\r\n    <ixs-label label=\"{{label}}\"></ixs-label>\r\n    <div class=\"col-md-9\">\r\n        <textarea class=\"form-control\" rows=\"9\"></textarea>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/textarea/textarea.component.html
// module id = 1218
// module chunks = 320